import { useScrollRestoration } from "@indietabletop/appkit";
import { useLocation } from "wouter";

const neverRestore = ["/", "/rules", "/join", "/login", "/settings"];

export function ScrollRestoration() {
  const [pathname] = useLocation();
  useScrollRestoration(pathname, { neverRestore });

  return null;
}
